import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { toLocale } from "~/libs/locale";
import en from "~/locales/en.json";
import fr from "~/locales/fr.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .on("languageChanged", (lng) => {
    document.documentElement.lang = toLocale(lng);
  })
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    nonExplicitSupportedLngs: true,
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    supportedLngs: ["en", "fr"],
  });
